"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fromStream = void 0;

var fs = require("./FsPromise");

var core = require("./core");

var FileTokenizer_1 = require("./FileTokenizer");

Object.defineProperty(exports, "fromFile", {
  enumerable: true,
  get: function get() {
    return FileTokenizer_1.fromFile;
  }
});

var core_1 = require("./core");

Object.defineProperty(exports, "EndOfStreamError", {
  enumerable: true,
  get: function get() {
    return core_1.EndOfStreamError;
  }
});
Object.defineProperty(exports, "fromBuffer", {
  enumerable: true,
  get: function get() {
    return core_1.fromBuffer;
  }
});
/**
 * Construct ReadStreamTokenizer from given Stream.
 * Will set fileSize, if provided given Stream has set the .path property.
 * @param stream - Node.js Stream.Readable
 * @param fileInfo - Pass additional file information to the tokenizer
 * @returns Tokenizer
 */

function fromStream(_x, _x2) {
  return _fromStream.apply(this, arguments);
}

function _fromStream() {
  _fromStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(stream, fileInfo) {
    var stat;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            fileInfo = fileInfo ? fileInfo : {};

            if (!stream.path) {
              _context.next = 7;
              break;
            }

            _context.next = 4;
            return fs.stat(stream.path);

          case 4:
            stat = _context.sent;
            fileInfo.path = stream.path;
            fileInfo.size = stat.size;

          case 7:
            return _context.abrupt("return", core.fromStream(stream, fileInfo));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fromStream.apply(this, arguments);
}

exports.fromStream = fromStream;